module.exports = __webpack_public_path__ + "img/orderbook-icon.a45173a3.svg";